export const getParselyUuid = () => window.PARSELY?.config?.parsely_site_uuid || '';
